import axios from "axios";
import apiURI from "./Api";

export default class ProfileAnalysisService {
  async createProfileAnalysis(token, analysis) {
    const response = await axios({
      method: "post",
      url: `${apiURI}/profile-analysis/create`,
      data: { profile_analysis: analysis },
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  }

  async getAllProfileAnalyses(token) {
    const response = await axios({
      method: "get",
      url: `${apiURI}/profile-analysis/getAll`,
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  }

  async getProfileAnalysisById(token, id) {
    const response = await axios({
      method: "get",
      url: `${apiURI}/profile-analysis/getById/${id}`,
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  }

  async updateProfileAnalysis(token, id, analysis) {
    const response = await axios({
      method: "post",
      url: `${apiURI}/profile-analysis/update/${id}`,
      data: { profile_analysis: analysis },
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  }
}
